<div style="height: 700px">
  <amplify-authenticator class="app-signin" [hideSignUp]="true">
    <ng-template amplifySlot="sign-in-header">
      <h3 class="amplify-heading" style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)">
        Sign in to your account
      </h3>
    </ng-template>
  </amplify-authenticator>
</div>